<template>
    <DCard
        :title="__('orders.show.fraud_detection')"
        :title-middle="__('orders.show.current_order_blocked_settings')"
        :main-title-has-slot="true"
        padding
    >
        <template #titleHasSlot>
            <DSwitch
                color="success"
                variant="3d"
                :disabled="isInLoadingState"
                :checked="showSection"
                @update:checked="showCardSection"
            />
        </template>
        <DRow v-if="showSection">
            <DCol col="6">
                <DFormRow :label="__('orders.show.fraud_score')">
                    {{ order.minFraudScore }}
                </DFormRow>
                <DFormRow :label="__('orders.show.recommendation')">
                    <DTag
                        v-if="order.minFraudRecommendation"
                        :label="__('orders.'+order.minFraudRecommendation)"
                        :color="order.minFraudRecommendation !== 'accept' ? 'danger' : 'secondary'"
                    />
                    <DTag
                        v-if="isPrepaidOrderWithInvoicingDisabled"
                        class="ms-1"
                        :label="__('orders.invoicing_disabled')"
                        color="danger"
                    />
                </DFormRow>
                <DFormRow :label="__('orders.show.location')">
                    {{ order.location }}
                </DFormRow>
            </DCol>
            <DCol col="6">
                <DFormRow
                    :label="__('orders.blocked')"
                >
                    <DTag
                        v-if="order.databaseCustomerOrdersBlocked === true"
                        :label="__('orders.blocked')"
                        color="danger"
                    />
                </DFormRow>
                <DFormRow :label="__('orders.order_blocked_reason')">
                    <span v-if="order.databaseCustomerOrdersBlocked === true">
                        {{ order.databaseCustomerOrderBlockedReason }}
                    </span>
                </DFormRow>
            </DCol>
        </DRow>
    </DCard>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'
import { ref } from 'vue'

const props = defineProps({
    order: {
        type: Object,
        default () {
            return {}
        }
    },
    section: {
        type: String,
        default () {
            return ''
        }
    },
    showSection: {
        type: Boolean,
        default () {
            return true
        }
    },
    userListView: {
        type: Array,
        default: () => {
            return []
        }
    },
    isPrepaidOrderWithInvoicingDisabled: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['update-list'])

const columns = ref(props.userListView)

const form = useForm({
    columns: props.userListView
})

function showCardSection (value) {
    for (const column of columns.value) {
        if (column.column === props.section) {
            column.show_column = value
        }
    }

    form.columns = flattenColumns(columns.value)

    form.post(route('settings.list-view-settings.store'))

    emit('update-list', columns.value)
}

function flattenColumns (columns) {
    if (columns.length === 0) {
        return {}
    }

    const result = {}

    for (const [key, column] of Object.entries(columns)) {
        result[key] = JSON.parse(JSON.stringify(column))
    }

    return result
}
</script>

<style scoped>

</style>
